import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CreateClientSecret, DeleteClientSecret, useClient } from "./ClientStore";

import {  useParams } from "react-router-dom";

const ClientSecrets = ({ user, policies }) => {
    const params = useParams();
    const [client, refresh] = useClient(params.id);

    const [secret, setSecret] = React.useState("");

    let hasPermission = (permission) => {
        if (user && policies) {
            if (user.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    };

    let createSecret = () => {
        CreateClientSecret(client.id).then((response) => {
            refresh();
            setSecret(response.data.secret);
        });
    };

    let deleteSecret = (secretId) => {
        DeleteClientSecret(client.id, secretId).then((response) => {
            refresh();
        });
    };

    let copySecret = () => {
        // @ts-ignore
        navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state == "granted" || result.state == "prompt") {
                navigator.clipboard.writeText(secret).then(
                    function () {
                        /* clipboard successfully set */
                    },
                    function () {
                        /* clipboard write failed */
                    }
                );
            }
        });
    };

    return (
        <>
            {hasPermission("manageClients") && client.id && (
                <table className="table">
                    <thead>
                        <tr>
                            <th>Secret</th>
                            <th>Created</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {client.secrets.map((secret, i) => (
                            <tr key={"s" + i}>
                                <td>{secret.value.substring(0, 20)}</td>
                                <td>{secret.created}</td>
                                <td>
                                    <button type="button" className="btn btn-outline-danger" onClick={() => deleteSecret(secret.id)}>
                                        <FontAwesomeIcon icon={["fad", "trash"]}></FontAwesomeIcon>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {secret && (
                            <tr>
                                <td className="text-danger">Copy this value before closing or navigating away from this page</td>
                                <td>{secret}</td>
                                <td>
                                    <button type="button" className="btn btn-outline" onClick={copySecret}>
                                        <FontAwesomeIcon icon={["fad", "link"]}></FontAwesomeIcon>
                                    </button>
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td colSpan={4}>
                                <a href="#" onClick={createSecret}>
                                    Add new secret
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </>
    );
};

export default ClientSecrets;
